export default "__VITE_ASSET__ByAJj$3$__"